module.exports = __webpack_public_path__ + "static/img/404.1d964cd1.svg";